<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-area-chart"></span>Analytics</div>
  </div>
  <div>
    <div>
      <div class="row">
        <div class="col-xl-4 col-lg-4">
          <p-card *ngIf="lastActivity.length>0">
            <div class="columns">
              <div class="sub-header flex">Activity in the Last 24 Hrs</div>
            </div>
            <div class="analytics-service height-limit">
              <div *ngFor="let record of lastActivity">
                <div class="widget-title">{{record.Partner}}</div>
                <div class="widget-metric">
                  <span pTooltip="The last activity was {{record.LastActivityDate | date : 'yyyy-MM-dd h:mma'}}"
                    tooltipPosition="left" class="fa"
                    [ngClass]="{'fa-smile-o green': record.ActivityInLast24HRS, 'fa-frown-o red': !record.ActivityInLast24HRS}"></span>
                </div>
              </div>
            </div>
          </p-card>

          <p-card *ngIf="posSyncActivity.length>0">
            <div class="columns">
              <div class="sub-header flex">POS Synced in last 24 Hours</div>
            </div>
            <div class="analytics-service height-limit">
              <div *ngFor="let record of posSyncActivity">
                <div class="widget-title">{{record.Partner}}</div>
                <div class="widget-metric">
                  <span pTooltip="The last sync date was {{record.LastSyncDate | date : 'yyyy-MM-dd HH:mm'}}"
                    tooltipPosition="left" class="fa"
                    [ngClass]="{'fa-smile-o green': record.POSSyncedInLast24HRS, 'fa-frown-o red': !record.POSSyncedInLast24HRS}"></span>
                </div>
              </div>
            </div>
          </p-card>

          <!-- <p-card>
            <div class="columns">
              <div class="sub-header flex">Quote Items Linked To Gear</div>
            </div>
            <div class="analytics-service">
              <div *ngFor="let record of quoteItemsLinkedToGear">
                <div class="widget-title">{{record.Partner}}</div>
                <div class="progress-wrapper">
                  <div class="current">{{record.LinkedToGears / record.LineItems * 100 | number : '0.0-1'}}%</div>
                  <round-progress [responsive]="true" [radius]="100" [stroke]="15" [rounded]="true" [clockwise]="true"
                    color="#00D969" [current]="record.LinkedToGears / record.LineItems * 100" max="100">
                  </round-progress>
                </div>
              </div>
            </div>
          </p-card> -->

          <p-card *ngIf="productsLinkedToGear && productsLinkedToGear.length>0">
            <div class="columns">
              <div class="sub-header flex">Products Linked to Gear</div>
            </div>
            <div class="analytics-service">
              <div *ngFor="let record of productsLinkedToGear">
                <div class="widget-title">{{record.Partner}}</div>
                <!--<div class="widget-metric">
                  {{record.LinkedToGear / record.SKU * 100 | number : '0.1-2'}} %
                </div>-->
                <div class="progress-wrapper">
                  <div class="current">{{record.LinkedToGear / record.SKU * 100 | number : '0.1-1'}}%</div>
                  <round-progress [responsive]="true" [radius]="100" [stroke]="15" [rounded]="true" [clockwise]="true"
                    color="#00D969" [current]="record.LinkedToGear / record.SKU * 100 " [max]="100"></round-progress>
                </div>
              </div>
            </div>
          </p-card>
        </div>

        <div class="col-xl-8 col-lg-8">

          <div class="row">
              <div class="col-md-3 col-lg-4">
                <div class="logins login-1">
                  <div class="period">App Users - Total</div>
                  <div class="metric">{{logins.allTime}}</div>
                </div>
              </div>
              <div class="col-md-3 col-lg-4">
                  <div class="logins login-2">
                      <div class="period">App Logins - Last Month</div>
                      <div class="metric">{{logins.lastMonth}}</div>
                    </div>
              </div>
              <div class="col-md-3 col-lg-4">
                  <div class="logins login-3">
                      <div class="period">App Logins - Last Week</div>
                      <div class="metric">{{logins.lastWeek}}</div>
                    </div>
              </div>
          </div>

          <p-card *ngIf="registrationsByOS.ios.labels.length>0">
            <div class="columns">
              <div class="sub-header flex">Mobile App Registrations iOS</div>
              <div style="margin:auto;">
                <img style="height:30px;" src="/assets/apple-icon.png">
              </div>
            </div>
            <div>
              <div class="chart-mobile">
                <canvas baseChart [legend]="false" [datasets]="registrationsByOS.ios.data"
                        [height]="75"
                        [options]="chartOptions"
                        [labels]="registrationsByOS.ios.labels" [type]="'line'"></canvas>
              </div>
<!--             todo (dcorbett) fix the mobile charts -->
            </div>
          </p-card>

          <p-card *ngIf="registrationsByOS.android.labels.length>0">
            <div class="columns">
              <div class="sub-header flex">Mobile App Registrations Android</div>
              <div style="margin:auto;">
                <img style="height:30px;" src="/assets/android-icon.png">
              </div>
            </div>
            <div>
              <div class="chart-mobile">
              <canvas baseChart [legend]="false" [datasets]="registrationsByOS.android.data"
                      [height]="75"
                      [options]="chartOptions"
                      [labels]="registrationsByOS.android.labels"
                      [type]="'line'"></canvas>
              </div>
            </div>
          </p-card>

          <p-card>
            <div class="columns">
              <div class="sub-header flex">Services Booked Per Day</div>
            </div>
            <div class="analytics-service">
              <table>
                <tr>
                  <th class="column-blank"></th>
                  <th class="column" *ngFor="let column of bookingsPerDay.columns">{{column | date : 'yyyy-MM-dd'}}</th>
                </tr>
                <tr *ngFor="let row of bookingsPerDay.rows;let i = index;">
                  <th>{{row}}</th>
                  <td *ngFor="let data of bookingsPerDay.data[i]">{{data}}</td>
                </tr>
              </table>
            </div>
          </p-card>

          <p-card>
            <div class="columns">
              <div class="sub-header flex">Service Statuses for the last Week</div>
            </div>
            <div class="analytics-service">
              <table>
                <tr>
                  <th class="column-blank"></th>
                  <th class="column" *ngFor="let column of bookingStatuses.columns">{{column | statusNames}}</th>
                </tr>
                <tr *ngFor="let row of bookingStatuses.rows;let i = index;">
                  <th>{{row}}</th>
                  <td *ngFor="let data of bookingStatuses.data[i]">{{data}}</td>
                </tr>
              </table>
            </div>
          </p-card>

          <p-card>
            <div class="columns">
              <div class="sub-header flex">Services Booked vs Invoiced For the last Week</div>
            </div>
            <div class="analytics-service">
              <table>
                <tr>
                  <th class="column-blank"></th>
<!--                todo (dcorbett) no statusNames   -->
                  <th class="column" *ngFor="let column of bookedInVsInvoices.columns">{{column | statusNames}}</th>
                </tr>
                <tr *ngFor="let row of bookedInVsInvoices.rows;let i = index;">
                  <th>{{row}}</th>
                  <td style="text-align: -webkit-center;" *ngFor="let data of bookedInVsInvoices.data[i]">
                    <div class="progress-wrapper" *ngIf="data>=0">
                      <div class="current">{{data | number : '0.0-1'}}%</div>
                      <round-progress [responsive]="true" [radius]="100" [stroke]="15" [rounded]="true"
                        [clockwise]="true" color="#00D969" [current]="data" [max]="100">
                      </round-progress>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </p-card>

        </div>

      </div>
    </div>
  </div>
